<template>
	<div>
		<md-button v-for="(value, index) in optionValues" :key="index"
				   class="margin_r font_bold"
				   :class="isOptionActive(value) ? 'md-primary' : 'md-blank'"
				   @click="toggleFilter(value)"
		>
			<i v-if="isOptionActive(value)" class="fa font_lg enum_icon fa-check"></i>
			{{ $t(enumDef.properties[value].key) }}
		</md-button>
	</div>
</template>
<script>

import {wrappers} from "@/common/utils/wrappers";
import {mapActions, mapGetters} from "vuex";

export default {
	props: {
		columnName: { type: String, default: null }, // Common column name for the filter if options do not specify it themselves
		optionValues: { type: Array }, // Values to be used for filtering
		defaultValue: { type: Number, default: null },
		enumDef: { type: Object }, // Enum definition matching provided values
		storageKey: { type: String, default: "" }, // Key to store/retrieve filters in investor preferences
	},
	data() {
		return {
			activeValues: []
		};
	},
	computed: {
		...mapGetters({
			quickFilters: "local/quickFilters"
		})
	},
	created() {
		this.loadFiltersFromPreferences();
	},
	methods: {
		...mapActions({ saveQuickFilter: "local/setQuickFilter" }),
		isOptionActive(value) {
			return this.activeValues.includes(value);
		},
		clearFilter() {
			this.setFilter([]);
		},
		getFilter() {
			if (this.activeValues.length === 0) {
				return [];
			}

			return [{
				columnName: this.columnName,
				fieldType: "I",
				matchType: "IN",
				value: wrappers.asArray(this.activeValues).join(",")
			}];
		},
		toggleFilter(value) {
			const index = this.activeValues.indexOf(value);

			if (index === -1) {
				// Value is not active, add it
				this.activeValues.push(value);
			} else {
				// Value is already active, remove it
				this.activeValues.splice(index, 1);
			}

			this.applyFilter();
		},
		setFilter(values) {
			this.activeValues = values;

			this.applyFilter();
		},
		applyFilter() {
			this.$emit("apply-filter", this.getFilter());
			this.saveFiltersToPreferences();
		},
		saveFiltersToPreferences() {
			if (!this.storageKey) {
				return;
			}

			this.saveQuickFilter({
				[this.storageKey] : this.activeValues
			});
		},
		loadFiltersFromPreferences() {
			let savedValues = [];

			if (this.storageKey && this.quickFilters && this.quickFilters[this.storageKey]) {
				// Filter out saved values that are no longer available
				savedValues = this.quickFilters[this.storageKey].filter(value =>
					this.optionValues.includes(value)
				);
			}

			// In case no filters have been saved before and they are no longer valid -> use default
			if (savedValues.length === 0) {
				savedValues = [ this.defaultValue ];
			}

			this.setFilter(savedValues);
		}
	}
};
</script>
